<template>
  <div class="page">
    <template v-if="!['/payments', '/instructionManual' , '/rewards'].includes(route.path)">
      <f-header />
      <Breadcrumb />
    </template>
    <router-view v-if="route.path == '/' || route.path == '/rewards'" />
    <div v-else class="main-container">
      <router-view />
    </div>
    <installApp v-if="route.path == '/'" />
    <footerVue
      v-if="!['/payments', '/instructionManual', '/rewards'].includes(route.path)"
    />
  </div>
</template>
<script setup>
import { getUserInfo } from "@/api/LoginRegister";
import { getMemberInfo } from "@/api/member";
import { getDicData } from "@/api/file";
import { onBeforeMount, onMounted } from "vue";
import { useUsersStore } from "@/stores/user";
import fHeader from "@/components/header.vue";
// 导航
import Breadcrumb from "@/components/breadcrumb.vue";
// app下载
import installApp from "@/components/installApp.vue";
// 底部
import footerVue from "@/components/footer.vue";
import { useRoute } from "vue-router";
const { isLogin } = useUsersStore();
const route = useRoute();
onMounted(() => {
  if (localStorage.getItem("userInfo") == "null") {
    localStorage.removeItem("userInfo");
  }
  getDicData({ sysDictType: "zipcodestack_apikey" }).then((res) => {
    console.log("zipcodestack_apikey", res.data);
    let apiKey = res.data.find((item) => item.dictValue == "apikey").dictLabel;
    useUsersStore().apiKey = apiKey;
    // localStorage.setItem("zipcodestack_apikey",res.data.sysDictValue)
  });
  if (isLogin) {
    getUserInfo().then((res) => {
      useUsersStore().userInfo = res.data;
      localStorage.setItem("userInfo", JSON.stringify(res.data));
    });
    getMemberInfo().then((res) => {
      if (res.code == 0 && res.data) {
        useUsersStore().memberInfo = res.data;
        localStorage.setItem("memberInfo", JSON.stringify(res.data));
      } else {
        useUsersStore().memberInfo = null;
        localStorage.removeItem("memberInfo");
      }
    });
  }
});
</script>

<style>
@import "@/assets/css/font.css";
@import "//at.alicdn.com/t/c/font_4074729_p3vybsa7yj.css";

.page {
  font-weight: 500;
  font-size: 20px;
}
</style>
